export default __webpack_public_path__ + "static/media/Mickey-Mouse-Cake.1cce6ec3.jpg";